import React from "react";
import ReactDOM from "react-dom/client"; // use 'react-dom/client' in React 18+
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'bootstrap/dist/css/bootstrap.min.css';


// Create the root using ReactDOM.createRoot (React 18+)
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Report web vitals (optional, can be removed if not needed)
reportWebVitals();
